import * as Role from '../../../../constants/role';
import * as Status from '../../../../constants/status';
import { isInspecaoMtBt } from 'utils';
import { isAnexoNsmp } from './nsmpRowTypes';

export const isDigitadorVinculado = ({ userRole, digitadorId, userId }) =>
  userRole === Role.DIGITADOR && Boolean(digitadorId && userId && digitadorId === userId);

/** MT/BT: digitador vinculado pode pré-visualizar serviços/fotos antes de iniciar a digitação. */
export const isMtBtDigitadorPreview = ({
  tipoServicoId,
  userRole,
  digitadorId,
  userId,
  nsirStatus,
}) =>
  isInspecaoMtBt(tipoServicoId) &&
  isDigitadorVinculado({ userRole, digitadorId, userId }) &&
  Status.canDigitar(nsirStatus);

export const isDigitadorEmDigitacao = ({ nsirStatus, digitadorId, userId, userRole }) =>
  nsirStatus === Status.EM_DIGITACAO &&
  isDigitadorVinculado({ userRole, digitadorId, userId });

export const getServicosShowEdit = ({
  nsirStatus,
  inspetorId,
  userId,
  userRole,
  digitadorId,
  tipoServicoId,
}) => {
  const isInspetor = nsirStatus === Status.EM_INSPECAO && inspetorId === userId;
  const digitadorAtivo = isDigitadorEmDigitacao({ nsirStatus, digitadorId, userId, userRole });
  const preview = isMtBtDigitadorPreview({
    tipoServicoId,
    userRole,
    digitadorId,
    userId,
    nsirStatus,
  });
  return isInspetor || (digitadorAtivo && !preview);
};

export const getServicosShowView = ({
  isAdmin,
  nsirStatus,
  userRole,
  digitadorId,
  userId,
  tipoServicoId,
}) => {
  if (isAdmin) return true;

  if (isMtBtDigitadorPreview({ tipoServicoId, userRole, digitadorId, userId, nsirStatus })) {
    return true;
  }

  if (
    isDigitadorEmDigitacao({ nsirStatus, digitadorId, userId, userRole }) &&
    isInspecaoMtBt(tipoServicoId)
  ) {
    return true;
  }

  return (
    nsirStatus !== Status.EM_INSPECAO &&
    nsirStatus !== Status.EM_DIGITACAO &&
    !(nsirStatus === Status.INSPECAO_FINALIZADA && userRole === Role.DIGITADOR)
  );
};

export const getServicosShowViewRow = (
  row,
  { nsirStatus, userRole, digitadorId, userId, tipoServicoId, isServiceRow },
) => {
  if (isMtBtDigitadorPreview({ tipoServicoId, userRole, digitadorId, userId, nsirStatus })) {
    return true;
  }

  if (
    isDigitadorEmDigitacao({ nsirStatus, digitadorId, userId, userRole }) &&
    isInspecaoMtBt(tipoServicoId) &&
    isAnexoNsmp(row)
  ) {
    return true;
  }

  if (
    nsirStatus === Status.EM_DIGITACAO &&
    isDigitadorVinculado({ userRole, digitadorId, userId }) &&
    isServiceRow(row)
  ) {
    return false;
  }

  return true;
};
